import { HttpError } from "./HttpError";

/**
 * Backend error codes
 *
 * Cf. https://gitlab.slsprototyp.de/backend/commons/blob/master/src/main/java/de/rhenus/commons/exception/RhenusHttpInternalStatus.java
 */
const errorCodes: { [key: number]: string } = {
  451: "COMPANY_NOT_FOUND",
  452: "USER_NOT_FOUND",
  453: "USER_ALREADY_EXISTS",
  454: "COMPANY_ALREADY_EXISTS",
  455: "INVALID_TOKEN",
  456: "INTERNAL_ERROR",
  457: "INVALID_ROLE",
  458: "JOB_ALREADY_CLOSED",
  459: "CAPTCHA_VALIDATION_FAILED",
  460: "FILE_FORMAT_NOT_SUPPORTED",
  461: "ORDER_NOT_FOUND",
  462: "USER_ADDRESS_NOT_FOUND",
  463: "QUELLDATEN_NOT_FOUND"
};

const errorMessages: { [key: string]: string } = {
  COMPANY_NOT_FOUND: "Die Firma konnte nicht gefunden werden.",
  USER_NOT_FOUND: "Der Benutzer konnte nicht gefunden werden.",
  USER_ALREADY_EXISTS:
    "Es existiert bereits ein Benutzerkonto unter der gewählten E-Mail-Adresse.",
  COMPANY_ALREADY_EXISTS:
    "Eine Firma mit dem gewählten Namen existiert bereits.",
  INVALID_TOKEN:
    "Der Aktivierungscode ist ungültig oder wurde bereits verwendet.",
  INTERNAL_ERROR: "Bei der Verarbeitung ist ein interner Fehler aufgetreten.",
  INVALID_ROLE:
    "Sie besitzen nicht hinreichende Berechtigungen diese Aktion durchzuführen.",
  JOB_ALREADY_CLOSED: "Der Auftrag wurde bereits abgeschlossen.",
  CAPTCHA_VALIDATION_FAILED:
    "Die Kontrollfrage wurde nicht korrekt beantwortet.",
  FILE_FORMAT_NOT_SUPPORTED:
    "Das Dateiformat entspricht nicht den Anforderungen.",
  ORDER_NOT_FOUND: "Der Auftrag konnte nicht gefunden werden.",
  USER_ADDRESS_NOT_FOUND:
    "Die benutzerdefinierte Adresse konnte nicht gefunden werden.",
  QUELLDATEN_NOT_FOUND: "Die Quelldatendatei konnte nicht gefunden werden."
};

export class ApiError extends HttpError {
  constructor(
    public apiErrorCode: number,
    response: Response,
    request: Request,
    ...params: any[]
  ) {
    super(response, request, ...params);
  }

  get message() {
    if (this.apiErrorCode in errorCodes) {
      const errorName = errorCodes[this.apiErrorCode];
      if (errorName in errorMessages) {
        return (
          "Aus folgendem Grund konnte die Anfrage nicht erfolgreich verarbeitet werden: " +
          errorMessages[errorName]
        );
      } else {
        return super.message + ` Der Fehler ${errorName} ist aufgetreten.`;
      }
    } else {
      return (
        super.message + ` Der Fehler #${this.apiErrorCode} ist aufgetreten.`
      );
    }
  }
}
